// extracted by mini-css-extract-plugin
module.exports = {"container":"recentChanges_container__RohR5"};